import { useDispatch } from "react-redux";
import { updateGooglemeetVisible, updateDimmed } from "../../../features/forms/formsSlice";
import {
  Overlay,
  GuideWrapper,
  Title,
  Subtitle,
  Steps,
  Step,
  ImagePlaceholder,
  Image,
  ButtonsWrapper,
  CloseButton,
} from "./GoogleMeetStyle";
import picture1 from "./01_images/Picture1.jpg"
import picture2 from "./01_images/Picture2.jpg"
import picture3 from "./01_images/Picture3.jpg"
import picture4 from "./01_images/Picture4.jpg"
import picture5 from "./01_images/Picture5.jpg"
import picture6 from "./01_images/Picture6.jpg"

const STEPS = [
  {
    text: 'Натисніть на посилання в електронному листі «Приєднатися до дзвінка».',
    imageName: picture1,
  },
  {
    text: 'Натисніть «Використовувати мікрофон і камеру».',
    imageName: picture2,
  },
  {
    text: 'Натисніть «Приєднатися зараз» або "Надіслати запит на приєднання" (якщо організатор ще не розпочав зустріч). Дочекайтеся приєднання до зустрічі.',
    imageName: picture3,
  },
  {
    text: "Натисніть три крапки внизу екрану.",
    imageName: picture4,
  },
  {
    text: "Виберіть «Налаштувати вигляд».",
    imageName: picture5,
  },
  {
    text: "Виберіть «Бічна панель» і закрийте вікно.",
    imageName: picture6,
  },
];

const GoogleMeetForm = ({ googlemeetVisible }) => {

    const dispatch = useDispatch()

  const close = (e) => {
    e?.preventDefault?.();
        dispatch(updateGooglemeetVisible(false))
        dispatch(updateDimmed(false))
    // if (typeof onClose === "function") onClose();
  };

  return (
    <>
      {/* Dim the whole website */}
      <Overlay googlemeetVisible={googlemeetVisible} onClick={close} />

      {/* Modal “page” */}
      <GuideWrapper googlemeetVisible={googlemeetVisible} role="dialog" aria-modal="true">
        <Title>Як приєднатися до зустрічі в Google Meet</Title>
        <Subtitle>Коротка інструкція (можна переглянути перед уроком)</Subtitle>

        <Steps>
          {STEPS.map((s, i) => (
            <Step key={i}>
              {s.text}
              <ImagePlaceholder>
                <Image src={s.imageName} />
              </ImagePlaceholder>
            </Step>
          ))}
        </Steps>

        <ButtonsWrapper>
          <CloseButton type="button" onClick={close}>
            Close
          </CloseButton>
        </ButtonsWrapper>
      </GuideWrapper>
    </>
  );
};

export default GoogleMeetForm;
